import React, { useState } from 'react';

// Define the component's props, including the new 'placeholder' prop
interface ImageWithPlaceholderProps {
  src?: string;
  alt: string;
  placeholder: React.ReactNode; // Can be any JSX, component, or element
  className?: string; // Optional class for the main container
}

const GGPlaceholderImage: React.FC<ImageWithPlaceholderProps> = ({
  src,
  alt,
  placeholder,
  className,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={className}>
      {/* Conditionally display the placeholder passed in via props */}
      <div style={{ display: isLoaded ? 'none' : 'inherit' }}>
        {placeholder}
      </div>

      {/* The actual image, hidden until it loads */}
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)}
        style={{ display: isLoaded ? 'block' : 'none' }}
        // Ensure the loaded image fits its container
        width="100%" 
        height="100%"
      />
    </div>
  );
};

export default GGPlaceholderImage;